module.exports = __webpack_public_path__ + "static/media/music.8a7155bd.jpg";